import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isBoolean, isString } from '../../lib/utils'
import styles from './button.scss'

export const TYPES = ['primary', 'secondary']

export const COLORS = ['green', 'red', 'grey']

export const SIZES = ['small', 'medium', 'large']

const Button = (props) => {
  const {
    children,
    type,
    color,
    padding,
    margin,
    width,
    height,
    size,
    full,
    disabled,
    onClick
  } = props

  const buttonClass = classNames(styles.button, {
    [styles[type]]: type,
    [styles[color]]: color,
    [styles.padding]: isBoolean(padding) && padding,
    [styles[size]]: size,
    [styles.full]: full,
    [styles.disabled]: disabled
  })

  const buttonStyle = {}

  if (isString(padding) && padding) buttonStyle.padding = padding

  if (isString(margin) && margin) buttonStyle.margin = margin

  if (width) buttonStyle.width = `${width}px`

  if (height) buttonStyle.height = `${height}px`

  return (
    <button
      className={buttonClass}
      style={buttonStyle}
      type="button"
      onClick={!disabled ? onClick : null}
    >
      {children}
    </button>
  )
}

Button.defaultProps = {
  children: null,
  type: null,
  color: null,
  padding: true,
  margin: null,
  width: null,
  height: null,
  size: null,
  full: false,
  disabled: false,
  onClick: null
}

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  type: PropTypes.oneOf(TYPES),
  color: PropTypes.oneOf(COLORS),
  padding: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  margin: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.oneOf(SIZES),
  full: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

export default Button
